import { Attribution } from 'types'

interface Params {
  endDate: string
  startDate: string
  attr: Attribution
}

export const getTotalSourcesSum = ({ endDate, startDate, attr }: Params) => {
  switch (attr) {
    case 'first':
      return `SELECT SUM(first.total_amount), SUM(first.recurring_payments_amount), SUM(first.orders_amount), SUM(first.ad_spend), SUM(stats.views), SUM(stats.new_visitors), SUM(first.new_customers), SUM(first.leads), SUM(first.total_orders) FROM source WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}'`
    case 'last':
      return `SELECT SUM(last.total_amount), SUM(last.recurring_payments_amount), SUM(last.orders_amount), SUM(last.ad_spend), SUM(stats.views), SUM(stats.new_visitors), SUM(last.new_customers), SUM(last.leads), SUM(last.total_orders) FROM source WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}'`
    case 'linear':
      return `SELECT SUM(linear_source.total_amount), SUM(linear_source.recurring_payments_amount), SUM(linear_source.orders_amount), SUM(linear_source.ad_spend), SUM(stats.views), SUM(stats.new_visitors), SUM(stats.new_customers), SUM(linear_source.leads), SUM(linear_source.total_orders) FROM source WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}'`
    case 'ai':
      return `SELECT SUM(ai_source.total_amount), SUM(ai_source.recurring_payments_amount), SUM(ai_source.orders_amount), SUM(ai_source.ad_spend), SUM(stats.views), SUM(stats.new_visitors), SUM(stats.new_customers), SUM(ai_source.leads), SUM(ai_source.total_orders) FROM source WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}'`
    default:
      return ''
  }
}
